import { makeObservable, observable } from "mobx"
import { Translation } from "models/faq.model"
import { htmlToTextTransform } from "@lib/html"
import { PostElementBackground } from "@serializers/article"

import { BaseModel } from "./base.model"

export class InappPurchasesModel extends BaseModel {
  // @ts-ignore
  constructor(params) {
    super(params)
    makeObservable(this)
  }

  @observable translations = [] as Translation[]
  @observable isPaymentEnabled = true as boolean
  @observable iOSBlocks = [] as Block[]
  @observable androidBlocks = [] as Block[]
  @observable bundleNamesGift = [] as BundleNames[]
  @observable bundleNamesInstantChat = [] as BundleNames[]
  @observable bundleNamesKoth = [] as BundleNames[]
  @observable bundleNamesChips = [] as BundleNames[]
  @observable bundleNamesMixedBundles = [] as BundleNames[]
  @observable bundles = [] as Bundle[]
  @observable currentTimestamp = (Date.now() / 1000) as number
  @observable backUrl = "" as string

  getInappPurchasesPage = async (type: InappTypes) => {
    try {
      const {
        translations,
        is_payment_enabled: isPaymentEnabled,
        ios_blocks: iOSBlocks,
        android_blocks: androidBlocks,
        bundle_names_gift: bundleNamesGift = [],
        bundle_names_instant_chat: bundleNamesInstantChat = [],
        bundle_names_koth: bundleNamesKoth = [],
        bundle_names_chips: bundleNamesChips = [],
        bundle_names_mixed_bundles: bundleNamesMixedBundles = [],
        payment_back_url: backUrl,
      } = await this.Providers.InappPurchasesProvider.find()

      this.applyData({
        translations,
        isPaymentEnabled,
        iOSBlocks,
        androidBlocks,
        bundleNamesGift,
        bundleNamesInstantChat,
        bundleNamesKoth,
        bundleNamesChips,
        bundleNamesMixedBundles,
        backUrl,
      })

      const allBundles = {
        gift: this.bundleNamesGift,
        instant_chat: this.bundleNamesInstantChat,
        koth: this.bundleNamesKoth,
        chips: this.bundleNamesChips,
        mixed_bundles: this.bundleNamesMixedBundles,
      }

      await this.getBundles(allBundles[type].map((i) => i.name))
    } catch {}
  }

  getBundles = async (bundleNames: string[]) => {
    try {
      const {
        results,
      } = await this.Providers.InappPurchasesProvider.getBundles(bundleNames)
      this.applyData({
        bundles: results.sort((a, b) => a.price - b.price),
        currentTimestamp: Date.now() / 1000,
      })
    } catch {}
  }

  getPaymentUrl = async (bundleName: string, userId: string) => {
    if (!bundleName || !userId) {
      return
    }

    try {
      const {
        pageURL,
      } = await this.Providers.InappPurchasesProvider.getPaymentUrl(
        bundleName,
        userId,
        this.backUrl,
      )
      return pageURL
    } catch {}
  }

  getTemplate = (key: string, simpleText = false) => {
    const find = this.translations.find((template) => template.key === key)
    if (find) {
      return simpleText ? htmlToTextTransform(find.value) : find.value
    }
    return ""
  }

  hydrate = (data: unknown) => {
    // @ts-ignore
    this.applyData({ translations: data?.translations })
    // @ts-ignore
    this.applyData({ isPaymentEnabled: data?.isPaymentEnabled })
    // @ts-ignore
    this.applyData({ iOSBlocks: data?.iOSBlocks })
    // @ts-ignore
    this.applyData({ androidBlocks: data?.androidBlocks })
    // @ts-ignore
    this.applyData({ bundleNamesGift: data?.bundleNamesGift })
    // @ts-ignore
    this.applyData({ bundleNamesInstantChat: data?.bundleNamesInstantChat })
    // @ts-ignore
    this.applyData({ bundleNamesKoth: data?.bundleNamesKoth })
    // @ts-ignore
    this.applyData({ bundleNamesChips: data?.bundleNamesChips })
    // @ts-ignore
    this.applyData({ bundleNamesMixedBundles: data?.bundleNamesMixedBundles })
    // @ts-ignore
    this.applyData({ bundles: data?.bundles })
    // @ts-ignore
    this.applyData({ currentTimestamp: data?.currentTimestamp })
    // @ts-ignore
    this.applyData({ backUrl: data?.backUrl })
  }

  serialize = () => {
    return {
      translations: this.translations,
      isPaymentEnabled: this.isPaymentEnabled,
      iOSBlocks: this.iOSBlocks,
      androidBlocks: this.androidBlocks,
      bundleNamesGift: this.bundleNamesGift,
      bundleNamesInstantChat: this.bundleNamesInstantChat,
      bundleNamesKoth: this.bundleNamesKoth,
      bundleNamesChips: this.bundleNamesChips,
      bundleNamesMixedBundles: this.bundleNamesMixedBundles,
      bundles: this.bundles,
      currentTimestamp: this.currentTimestamp,
      backUrl: this.backUrl,
    }
  }
}

export interface Block {
  background: PostElementBackground
  Content: string
}

export interface BundleNames {
  name: string
  postfix: string
}

export interface Bundle {
  currency: "RUB"
  description: string
  has_trial: boolean
  name: string
  price: number
  price_trial: number
}

export type InappTypes =
  | "gift"
  | "instant_chat"
  | "koth"
  | "chips"
  | "mixed_bundles"
